import { render, staticRenderFns } from "./BText.vue?vue&type=template&id=2908f6c2&scoped=true&"
import script from "./BText.vue?vue&type=script&lang=js&"
export * from "./BText.vue?vue&type=script&lang=js&"
import style0 from "./BText.vue?vue&type=style&index=0&id=2908f6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908f6c2",
  null
  
)

export default component.exports